<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Charged Energy over Time" chart.
    </rb-callout>
</div>
<div id="charged-energy-over-time"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Total energy charged in the last {{numberMonths}} months, it helps to track usage, optimize costs, and improve efficiency.
    </div>
</div>